import React from 'react';

interface LearningPhotosProps {
  onBack: () => void;
}

const photos = [
  { file: 'Flashcard_Sentence Material.jpeg', alt: 'Hands-on sentence building with letter cards' },
  { file: 'Fractions.jpeg', alt: 'A learner working with fraction materials' },
  { file: 'Golden Beads.jpeg', alt: 'Golden bead Montessori math materials' },
  { file: 'Mult Beads.jpeg', alt: 'A learner using a multiplication bead board' },
  { file: 'Mult Rainbow Beads.jpeg', alt: 'Colorful multiplication bead materials' },
  { file: 'Place Value.jpeg', alt: 'A learner exploring place value with beads' },
  { file: 'Reading Break.jpeg', alt: 'A learner taking a reading break' },
  { file: 'Sandpaper letter.jpg', alt: 'Montessori sandpaper letter material' },
  { file: 'Sandpaper number.jpg', alt: 'Montessori sandpaper number material' },
  { file: 'Tots Pic.jpeg', alt: 'ETA Tots learning activity' },
  { file: 'Tots.jpeg', alt: 'ETA Tots classroom materials' },
];

const LearningPhotos: React.FC<LearningPhotosProps> = ({ onBack }) => (
  <main className="min-h-[70vh] bg-gradient-to-b from-white to-blue-50 px-4 py-12 md:py-16">
    <div className="mx-auto max-w-7xl">
      <h1 className="text-center text-3xl font-bold text-gray-900 md:text-4xl">
        Learning Photos
      </h1>
      <p className="mx-auto mt-4 max-w-2xl text-center text-gray-600">
        A glimpse of the hands-on materials and learning experiences at ETA Learning.
      </p>
      <div className="mt-8 text-center">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex min-h-[44px] items-center justify-center rounded-full border border-gray-300 bg-white px-6 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
        >
          &larr; Back to Home
        </button>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {photos.map(({ file, alt }) => (
          <figure key={file} className="overflow-hidden rounded-2xl bg-white shadow-md ring-1 ring-black/5">
            <img
              src={`${process.env.PUBLIC_URL}/eta_photos/${file}`}
              alt={alt}
              loading="lazy"
              decoding="async"
              className="aspect-[4/3] w-full object-cover transition-transform duration-300 hover:scale-[1.02]"
            />
          </figure>
        ))}
      </div>
    </div>
  </main>
);

export default LearningPhotos;
